export default "__VITE_ASSET__62091b70__"